import { c as _c } from "react/compiler-runtime";
import useDataStore from "@/features/home/model/data/store";
import { TextButton } from "@/shared/ui/atoms";
interface ProcedureItemProps {
  treatmentKey: string;
  interestList: Array<Record<string, string>>;
}
const ProcedureItem = t0 => {
  const $ = _c(9);
  const {
    interestList
  } = t0;
  const {
    interestProcedure,
    setInterestProcedure
  } = useDataStore();
  let t1;
  if ($[0] !== interestList || $[1] !== interestProcedure || $[2] !== setInterestProcedure) {
    let t2;
    if ($[4] !== interestProcedure || $[5] !== setInterestProcedure) {
      t2 = (interest, index) => {
        const key = Object.keys(interest)[0];
        const name = Object.values(interest)[0];
        return <TextButton key={`interest-item-${index}`} text={name} size={15} className={interestProcedure.includes(key) ? "w-fit py-2 px-[14px] border border-[#C9B8FF] rounded-full leading-[22px] text-primary bg-[#F6F2FF] font-semibold" : "w-fit py-2 px-[14px] border border-[#E1E2E4] rounded-full leading-[22px] text-[#5A5C63] font-medium"} onClick={() => {
          setInterestProcedure(key);
        }} />;
      };
      $[4] = interestProcedure;
      $[5] = setInterestProcedure;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = interestList.map(t2);
    $[0] = interestList;
    $[1] = interestProcedure;
    $[2] = setInterestProcedure;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="flex flex-wrap gap-x-2 gap-y-[10px]">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default ProcedureItem;